import http from '@/shared/api/http'

export async function generateProductDraftPreview(jobId, revisionId, request) {
  return (await http.post(`/import-jobs/${jobId}/column-mapping-revisions/${revisionId}/excel-product-type-drafts/product-drafts/preview`, request, { timeout: 120000 })).data
}

const reviewPath = (jobId, revisionId) =>
  `/import-jobs/${jobId}/column-mapping-revisions/${revisionId}/excel-product-type-drafts/product-drafts/review`

export async function getProductDraftReview(jobId, revisionId) {
  return (await http.get(reviewPath(jobId, revisionId))).data
}

export async function saveProductDraftReview(jobId, revisionId, request) {
  return (await http.put(reviewPath(jobId, revisionId), request)).data
}

export async function setProductDraftInclusion(jobId, revisionId, request) {
  return (await http.put(`${reviewPath(jobId, revisionId)}/selection`, request)).data
}

export async function saveProductDraftOverride(jobId, revisionId, request) {
  return (await http.put(`${reviewPath(jobId, revisionId)}/overrides`, request)).data
}

export async function replaceProductDraftImages(jobId, revisionId, request) {
  return (await http.put(`${reviewPath(jobId, revisionId)}/images`, request)).data
}

export async function preflightProductDraftReview(jobId, revisionId, request) {
  return (await http.post(`${reviewPath(jobId, revisionId)}/preflight`, request)).data
}

export async function confirmProductDraftReview(jobId, revisionId, request) {
  return (await http.post(`${reviewPath(jobId, revisionId)}/confirm`, request)).data
}

export async function getLatestProductDraftSnapshot(jobId, revisionId, reviewStateId) {
  return (await http.get(`${reviewPath(jobId, revisionId)}/confirmed-snapshots/latest`, { params: { reviewStateId } })).data
}

export async function applyProductDraftSnapshot(jobId, revisionId, snapshotId, payloadChecksum) {
  return (await http.post(`${reviewPath(jobId, revisionId)}/confirmed-snapshots/${snapshotId}/apply`, { payloadChecksum })).data
}

export async function getProductDraftApplyResult(jobId, revisionId, snapshotId) {
  return (await http.get(`${reviewPath(jobId, revisionId)}/confirmed-snapshots/${snapshotId}/apply-result`)).data
}
